/**
 *
 * @param {Array<*>} source
 * @param {Array<number | string>} items
 * @param {string | null} sourceProperty
 */
export default function subtractArrays(
  source,
  itemsToBeRemovedFromSource,
  sourceProperty = null,
) {
  const itemsHashTable = {};

  itemsToBeRemovedFromSource.forEach(item => {
    itemsHashTable[item] = true;
  });

  return source.filter(sourceItem => {
    if (sourceProperty) {
      return !(sourceItem[sourceProperty] in itemsHashTable);
    }
    return !(sourceItem in itemsHashTable);
  });
}
